import { DialogService, ModalVerArchivoComponent } from "shared";
import { IAppMenu } from "../store/app.store.model";
import { IComboList } from "../types/server-response";

export namespace CORE_FUNCTIONS {


    export function buildMenu(rawMenu: any[], id = 0): IAppMenu[] {

        const menu = rawMenu.filter(x => x.idMenuPadre == id);

        if (menu.length == 0) return null;

        return menu.map(x => ({
            idMenu: x.idMenu,
            label: x.menu,
            icon: x.icono || 'view_module',
            route: x.ruta,
            children: buildMenu(rawMenu, x.idMenu)
        }));
    }

    function buildFormData(formData: FormData, data: any, parentKey = undefined) {
        if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
            let separationOpen = '';
            let separationClose = '';
            Object.keys(data).forEach((key: any) => {
                if (isNaN(key) === true) {//es letra
                    separationOpen = '.';
                    separationClose = '';
                } else {//es número
                    separationOpen = '[';
                    separationClose = ']';
                }
                buildFormData(formData, data[key], parentKey ? `${parentKey}${separationOpen}${key}${separationClose}` : key);
            });
        } else {
            const value = data == null ? '' : data;
            console.log(value);
            formData.append(parentKey, value);
        }
    }

    // function buildFormData(formData, data, parentKey = null) {
    //     if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    //         Object.keys(data).forEach(key => {
    //             buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    //         });
    //     } else {
    //         const value = data == null ? '' : data;

    //         formData.append(parentKey, value);
    //     }
    // }

    export function jsonToFormData(data, parentKey = undefined) {
        const formData = new FormData();

        buildFormData(formData, data, parentKey);

        return formData;
    }



    // export function jsonToFormData(val, formData = new FormData, namespace = '') {
    //     if ((typeof val !== 'undefined') && val !== null) {
    //         if (val instanceof Date) {
    //             formData.append(namespace, val.toISOString());
    //         } else if (val instanceof Array) {
    //             for (let i = 0; i < val.length; i++) {
    //                 jsonToFormData(val[i], formData, namespace + '[' + i + ']');
    //             }
    //         } else if (typeof val === 'object' && !(val instanceof File)) {
    //             for (let propertyName in val) {
    //                 if (val.hasOwnProperty(propertyName)) {
    //                     jsonToFormData(val[propertyName], formData, namespace ? `${namespace}[${propertyName}]` : propertyName);
    //                 }
    //             }
    //         } else if (val instanceof File) {
    //             formData.append(namespace, val);
    //         } else {
    //             formData.append(namespace, val.toString());
    //         }
    //     }
    //     return formData;
    // }

    export function getParametroDetalle(list: any[], idParametro: number) {
        const item = list.find(x => x.idParam == idParametro);

        if (!item) return null;

        return item.valor;
    }

    export function downloadFile(response: any, nameFile: string) {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(
            new Blob(binaryData, { type: dataType }),
        );
        downloadLink.setAttribute('download', nameFile);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    export const calculateSum = (arr, field) => {
        return arr
            .map(item => item[field])
            .reduce((prev, curr) => prev + curr, 0);
    }

    export function VerArchivoHandler(
        dialogService: DialogService,
        blob: Blob,
        nombreArchivo: string
    ) {
        const switchFunction = (value, { blob }) => ({
            'application/pdf': (() => {
                dialogService.openLG(ModalVerArchivoComponent, { data: { blob } });
            }),
            'application/msword': (() => CORE_FUNCTIONS.downloadFile(blob, nombreArchivo)),
            'image/jpeg': (() => {
                dialogService.openLG(ModalVerArchivoComponent, { data: { blob } });
            })
        }[value] || (() => { CORE_FUNCTIONS.downloadFile(blob, nombreArchivo); }));

        switchFunction(blob.type, { blob })();
    };

    export const ValidarValoresArray = (arr: any[]) => {
        const c = arr.filter(v => v == null || v == undefined).length;
        return c == 0 || c == arr.length ? true : false;

    }

    export const buildComboList = (list: any[] = []): IComboList => {
        return {
            list,
            loading: false
        }
    }

    export const ifNull = (element: any, _default: any) => {
        return element === null ? _default : element;
    }

    export const ifUndefined = (element: any, _default: any) => {
        return element === undefined ? _default : element;
    }

    export const ifNullOrUndefined = (element: any, _default: any) => {
        return element === undefined || element === null ? _default : element;
    }

    export const numberSpaces = price => String(price).replace(
        /(?!^)(?=(?:\d{3})+$)/g,
        ' '
    );

    export const calcPercent = (cant, total, round: boolean = true) => {
        const percent = (cant / total) * 100;
        return !round ? percent : Math.round(percent);
    }
}

